import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/wacol/footer';
import Header from '../components/wacol/header';
import HomePage from '../pages/wacol/home_page';
import AboutPage from '../pages/wacol/about_page';

export default function WacolTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                aboutPage={AboutPage}
            />
            <Footer />
        </React.Fragment>
    )
}
